import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { ToastContainer, toast } from 'react-toastify';
import { bannerAPI, newsAPI, videoAPI, adsAPI, imagaeAPI, YouTubevideoAPI, BengaluruNewsAPI, KarnatakaNewsAPI, NationalNewsAPI, YouTubevideoMetroAPI } from '../../services/api';
import Header from './Header';
import Footer from './Footer';

// Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// React Toastify CSS
import 'react-toastify/dist/ReactToastify.css';

// ---------- Main Homepage Component ----------
const AboutUs = () => {
    // State
    const [loading, setLoading] = useState(false);
    const [banners, setBanners] = useState([]);
    const [allNews, setAllNews] = useState([]);
    const [videos, seideos] = useState([]);
    const [ads, setAds] = useState([]);
    const [temperature, setTemperature] = useState('Loading...');
    const [youtubevideos, setYouTubeVideos] = useState([]);
    const [youtubevideosmetro, setYouTubeVideosMetro] = useState([]);
    const [error, setError] = useState(null);

    const [bengaluruallNews, setBengaluruAllNews] = useState([]);
    const [karnatakaallNews, setKarnatakaAllNews] = useState([]);
    const [nationalallNews, setNationalAllNews] = useState([]);


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        return new Date(dateStr).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });

    };





    const fetchAds = async () => {
        setLoading(true);
        try {
            const res = await adsAPI.getAll();
            setAds(res.data.data);
        } catch (error) {
            console.error("Error fetching ads:", error);
        }
        finally {
            setLoading(false);
        }
    };



    const getAds = () =>
        ads.filter(n => n.status === 'active');



    useEffect(() => {



        fetchAds();


        fetch('https://wttr.in/Bengaluru?format=j1')
            .then(res => res.json())
            .then(data => {
                setTemperature(data.current_condition[0].temp_C + '°C');
            })
            .catch(() => setTemperature('N/A'));

    }, []);


    if (loading) {
        return (
            <div className="main-content" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }



    // ---------- Render ----------
    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} />

            <Header temperature={temperature} />


            {/* ===== MAIN CONTENT ===== */}
            <main>

                {/* ---------- BENGALURU NEWS ---------- */}
                <section className="trending-posts-4__area trending-posts-4__space grey-bg section-space-bottom">
                    <div className="container custom-container">
                        <div className="trending-posts-4__top heading-display__wrap">
                            <div className="section-heading__wrap">
                                <h3 className="section__title wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s">
                                    About Us
                                </h3>
                                <div className="section__border wow custom-anim-left" data-wow-duration="1s" data-wow-delay="0.1s" />
                            </div>

                        </div>
                        <div className="row mb-minus-24">
                            <div className="col-lg-8 primary_bg4">

                                <div className="trending-posts-4__wrapper mb-24">

                                    <div className="header-4__location d-none d-md-block mb-24">
                                        <Link to="/contact">
                                            <img src="assets/img/team/nagabhushan.jpeg" alt="Nagabhushan J" className="editor-img" />
                                        </Link>
                                        <div className="editor-info">
                                            <h5>Nagabhushan</h5>
                                            <p className="qualification">B.Com., LL.B., PGDBA., PGDCA., ICWA (Inter)</p>
                                            <p className="designation">Editor-In-Chief</p>
                                            <p className="qualification">karnatakapolicenews@gmail.com</p>

                                        </div>
                                    </div>

                                    <div>
                                        <h3 className="mb-24">Venkatadri Weekly News  <br />A Journey of Two Decades in Service of Policing</h3>
                                        <p className="mb-24">Founded in 2007 by veteran journalist Nagabhushan, Venkatadri Weekly News  has emerged as a unique and respected platform dedicated to the police fraternity. Guided by the motto “For the Police, By the Police, and Of the Police,” the magazine has spent nearly two decades highlighting the achievements, challenges, and contributions of police personnel across Karnataka.</p>
                                        <p className="mb-24">Before launching the magazine, Nagabhushan served as a Crime Reporter for over 15 years, working with leading newspapers, news agencies, and electronic media organizations. His extensive experience covering crime, law enforcement, and public safety provided him with an in-depth understanding of policing and the vital role played by police officers in society.</p>
                                        <p className="mb-24">Recognizing the need for a dedicated platform that would showcase the positive side of policing and strengthen public confidence in law enforcement, he established Venkatadri Weekly News . Since its inception, the publication has consistently documented inspiring stories of courage, integrity, professionalism, and public service rendered by police officers across the state.</p>
                                        <p className="mb-24">As the magazine enters its 20th year of publication, it stands as a trusted bridge between the police department and the public. Over the years, Venkatadri Weekly News  has conducted exclusive interviews with numerous IPS officers, senior police officials, and frontline personnel, bringing to light their remarkable achievements, innovative initiatives, and exemplary service.</p>
                                        <p className="mb-24">One of the magazine's flagship initiatives is the Venkatadri Weekly News  Anniversary Celebration, during which outstanding police officers are recognized and honoured with the prestigious Best Cops Awards and Certificates of Excellence. These awards celebrate dedication, leadership, investigative excellence, community policing, and exceptional contributions to public safety.​</p>
                                        <p className="mb-24">Through its publications, special reports, interviews, and recognition programs, Venkatadri Weekly News  continues to uphold its commitment to promoting transparency, professionalism, and public awareness while celebrating the men and women who serve in uniform.</p>
                                        <p className="mb-24">Today, as Venkatadri Weekly News  steps into its twentieth year, it remains steadfast in its mission to chronicle the evolving story of policing, honour excellence, and strengthen the bond between law enforcement agencies and the citizens they serve.</p>
                                        <h3 className="mb-24">Venkatadri Weekly News  <br /> A Unique Digital Initiative</h3>
                                        <p className="mb-24">Venkatadri Weekly News  is a pioneering digital media platform dedicated to showcasing the invaluable service, achievements, challenges, and contributions of the police fraternity. Conceived with the vision of strengthening the bond between law enforcement agencies and the public, the platform serves as a bridge for awareness, education, and constructive dialogue.</p>
                                        <p className="mb-24">Operating in both Kannada and English, Venkatadri Weekly News  delivers comprehensive coverage of Police News, Crime, Law & Order, Politics, Sports, Business, Entertainment, Lifestyle, Travel, and Public Interest Issues. Through its digital portal and video content, the channel provides timely news updates, exclusive reports, interviews, special features, and public awareness programs.</p>
                                        <p className="mb-24">What makes Venkatadri Weekly News  truly distinctive is its exclusive focus on policing and public safety. The platform regularly features interactions with senior police officers, legal experts, administrators, academicians, and eminent personalities from various fields, helping citizens better understand the laws of the land and their implementation.</p>
                                        <p className="mb-24">The channel's mission extends beyond reporting news. It seeks to highlight the selfless service rendered by police personnel who work tirelessly to ensure the safety, security, and well-being of society. Through informative and engaging programs, Venkatadri Weekly News  aims to promote transparency, trust, and mutual understanding between the police force and the public.</p>



                                        <p className="mb-24">Venkatadri Weekly News  aspires to be the first comprehensive media platform in India dedicated to presenting a holistic view of policing, public safety, governance, and citizen participation. While the vision is ambitious, the platform is driven by a commitment to responsible journalism, public service, and social welfare.</p>
                                        <p className="mb-24">With the support of police officers, professionals, and well-wishers from various sectors, Venkatadri Weekly News  continues its journey towards creating an informed, aware, and responsible society.</p>


                                    </div>
                                    <div>
                                        <p className="mb-24"><img src="assets/img/advertisement/nagaaward1.jpg" alt="Nagabhushan J" className="img-fluid w-100" /></p>
                                        <p><img src="assets/img/advertisement/nagaaward2.jpg" alt="Nagabhushan J" className="img-fluid w-100" /></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="blog-sidebar__wrapper">



                                    <div
                                        className="blog-sidebar__wrap mb-20 wow fadeInUp"
                                        data-wow-duration="0.7s"
                                        data-wow-delay="0.2s"
                                    >
                                        <h3 className="blog-sidebar__title">Advertisement</h3>
                                        <div className="blog-sidebar__gallery blog-sidebar__gallery-2">


                                            {ads.length > 0 && (

                                                <>


                                                    {ads.map((ad) => (

                                                        <div className="" key={ad.id}>

                                                            <img src={`${imagaeAPI}/uploads/ads/${ad.ads_photo}`} alt={ad.ads_title} />

                                                        </div>

                                                    ))
                                                    }

                                                </>

                                            )}



                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>














            </main >

            {/* ===== FOOTER ===== */}

            < Footer />

        </>
    );
};

// ---------- SUBCOMPONENTS ----------



export default AboutUs;